import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.css"
import VueGtag from "vue-gtag";

createApp(App).use(VueGtag, {
    config: { id: "G-P1CL1KV7GJ" }
  }, router).use(store).use(router).mount('#app')

import "bootstrap/dist/js/bootstrap.bundle.js"
